import { WORKSPACE_IDS } from '@/configs/workspace-ids';

export const FACE_CREAM_WORKSPACE_ALIAS = WORKSPACE_IDS.FACE_CREAM;
